import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import getLangLocale from 'I18n/utils/getLangLocale';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import Raven from 'raven-js';
import { EN } from '../constants/Languages';
export const getI18nLangLocale = () => {
  const langLocale =
  // @ts-expect-error dependency missing types
  I18n.loaded && I18n.locale ? getLangLocale() : `${EN}-us`;
  return langLocale;
};
export const I18nLookup = val => {
  return isValidI18nKey(val);
};
export const findValidI18nKey = keys => {
  // @ts-expect-error dependency missing types
  return keys.find(key => I18n.lookup(key));
};
export const getI18nLanguage = () => {
  // @ts-expect-error dependency missing types
  const lang = I18n.loaded && I18n.locale ? getLang() : 'en';
  return lang;
};
export const getI18nText = (key, options) => {
  if (!isValidI18nKey(key)) return key;
  const text = I18n.text(key, Object.assign({
    defaultValue: ''
  }, options));
  if (typeof text === 'function') {
    Raven.captureException(new Error('Attempted to call I18n.text with _jsx key'), {
      extra: Object.assign({
        key
      }, options)
    });
    return key;
  }
  return text;
};
const languageIsInMap = (lang, langMap) => {
  return Object.keys(langMap).includes(lang);
};
export const languageToUrl = langMap => {
  const lang = getI18nLanguage();
  if (!languageIsInMap(lang, langMap)) {
    return langMap.en;
  }
  return langMap[lang];
};